module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/ae6111f55adff7057982ed08fa500128.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_manage_students.svg
// module id = 41oH
// module chunks = 1